import { Dispatch } from '../components/architecture/frontend/index'
import { filter, withLatestFrom, map, share, debounceTime } from 'rxjs/operators'
import {merge, combineLatest} from 'rxjs'
import _ from 'lodash'
import mutations from './Helpers/mutations'

import bufferObject from './bufferObject'

bufferObject('shipments')

// FIX ME: these should not be hardcoded to database IDs, maybe use slugs instead
const views = {
  claimsDenied: 1000,
  // Received Shipments
  receivingClaimsAwaitingPayment: 10,
  receivingClaimsSendToSupplier: 9,
  receivingClaimsNeedingInvoice: 8,
  receivingClaimsNeedingResults: 7,

  // Sent Shipments
  claimsRequiringPayment: 5,
  claimsAwaitingReferee: 4,
  claimSendToReferee: 3,
  claimNeedingShipment: 2,
  incompleteShipment: 1,
  claimTable: null,
  shipmentTable: null,
}

const loadShipments$ = merge(
  Dispatch.getAction('view')
    .pipe(
      map(e => ({ status: views[e.type], filter: e.details })),
      filter(e => !_.isUndefined(e.status)),
    ),
  Dispatch.getAction('Response.sendToSupplier')
    .pipe(
      map(e => ({ status: views['receivingClaimsSendToSupplier']})),
    ),
  Dispatch.getAction('Response.sendRefereeShipments')
    .pipe(
      map(e => ({ status: views['claimSendToReferee']})),
    ),
  Dispatch.getAction('Response.sendSettlement')
    .pipe(
      map(e => ({ status: views['claimsRequiringPayment']})),
    ),
  Dispatch.getAction('shipments.modal.search')
    .pipe(
      map(e => ({ status: views['claimsNeedingShipment'], filter: e})),
      debounceTime(500)
    ),
  Dispatch.getAction('__.Modal.open')
    .pipe(
      filter(e => e.type === 'shipmentSelect'),
      map(e => ({ status: views['claimsNeedingShipment']}))
    )
)
.pipe(
  share()
)

// merge(loadShipments$)
//   .subscribe(e => Dispatch.nextState('shipments', 'loading'))

combineLatest(loadShipments$, Dispatch.getState('table.sortBy'))
  .subscribe(([e, sortBy]) => {
    Dispatch.nextAction('__.buffer.setLoading.shipments')
    Dispatch.nextAction('Request.shipments', { type: 'query', query: mutations.GET_SHIPMENTS, variables: { status: e.status, filter: e.filter, sortBy: sortBy.field, sortOrder: sortBy.order } })
  })


  merge(
    Dispatch.getAction('Response.shipments'), 
    Dispatch.getAction('Response.shipments.toReferee'), 
    Dispatch.getAction('Response.saveShipments'),
    Dispatch.getAction('Response.sendRefereeShipments'),
    Dispatch.getAction('Response.sendSettlement'),
    Dispatch.getAction('Response.sendDenied'),
    //Dispatch.getAction('Response.shipments.refereeUpload'),
    Dispatch.getAction('Response.shipments.delete')
    )
    .pipe(
      filter(e => _.isNil(e.errors)),
      map(e => e.data.shipments ?? 
        e.data.upsertShipments ?? 
        e.data.sendReferee ?? 
        e.data.sendSettlement ?? 
        e.data.uploadReferee ?? 
        e.data.deleteShipments ?? 
        e.data.sendDenied
      ),
      //map(e => e.map(shipment => ({...shipment, sampleTypeId: shipment.sampleType?.id})))
    )
  .subscribe(e => Dispatch.nextAction('__.buffer.setRawAndClearBuffer.shipments', e))

  // Referee Upload is separate from normal buffer clearing due to file upload wiping out entered data
  Dispatch.getAction('Response.shipments.refereeUpload')
    .pipe(
      filter(e => _.isNil(e.errors)),
      map(e => e.data.uploadReferee),
    )
  .subscribe(e => Dispatch.nextAction('__.buffer.setRaw.shipments', e))

  Dispatch.getAction('shipments.loadMore')
    .pipe(
      withLatestFrom(Dispatch.getState('shipments.rawData'), Dispatch.getState('view'), Dispatch.getState('table.sortBy'))
      //update view count, request shipments
    )
    .subscribe(([,shipments, view, sort]) => {
      Dispatch.nextAction('Request.shipmentsLoadMore', { 
        type: 'query', 
        query: mutations.GET_SHIPMENTS, 
        variables: { 
          status: views[view.type], 
          filter: view.details, 
          cursor: shipments?.[shipments.length - 1]?.id, 
          sortBy: sort.field,
          sortOrder: sort.order
        }, 
      })
      //Dispatch.nextState('view.count', view?.count + 200)
    })

  Dispatch.getAction('Response.shipmentsLoadMore')
    .pipe(
      filter(e => _.isNil(e.errors)),
      map(e => e.data.shipments ?? e.data.upsertShipments ?? e.data.sendReferee),
     // map(e => e.map(shipment => ({...shipment, sampleTypeId: shipment.sampleType?.id}))),
      withLatestFrom(Dispatch.getState('shipments.rawData'))
    )
    .subscribe(([newData, oldData]) => Dispatch.nextAction('__.buffer.setRaw.shipments', [...oldData, ...newData]))
// merge(
//   Dispatch.getAction('Response.shipments'), 
//   Dispatch.getAction('Response.shipments.toReferee'), 
//   Dispatch.getAction('Response.saveShipments'),
//   Dispatch.getAction('Response.sendRefereeShipments'),
//   )
//   .pipe(
//     filter(e => _.isNil(e.errors)),
//     map(e => e.data.shipments ?? e.data.upsertShipments ?? e.data.sendReferee),
//     map(e => e.map(shipment => ({...shipment, sampleTypeId: shipment.sampleType?.id})))
//   )
//   .subscribe(e => Dispatch.nextState('shipments', e))

 Dispatch.getAction('shipments.toReferee')
    .pipe(
      withLatestFrom(Dispatch.getState('shipments')),
      map(([updates, shipments]) => {
        const filteredShipments = _.filter(shipments, shipment => _.includes(updates.map(e => e.id), shipment.id))
        return filteredShipments.map(shipment => ({...shipment, refereeToSend: _.find(updates, update => update.id === shipment.id).value }))
      }),
      map(e => e.map(shipment => mutations.createShipmentInput(shipment))),
      withLatestFrom(Dispatch.getState('view')),
      map(([shipment, view]) => ({ shipment, status: views[view.type]}))
    )
  .subscribe(e => Dispatch.nextAction('Request.shipments.toReferee', { type: 'mutation', query: mutations.MUTATE_UPSERT_SHIPMENTS, variables: { shipment: e.shipment, status: e.status } }))

// Dispatch.getAction('shipments.set')
//   .pipe(
//     withLatestFrom(Dispatch.getState('shipments')),
//     map(([update, shipments]) => {
//       const index = _.findIndex(shipments, shipment => shipment.id === update.id)
//       const value = shipments[index][update.field] = update.value
//       return shipments
//     })
//   )
//   .subscribe(e => Dispatch.nextState('shipments', e))



Dispatch.getAction('shipments.save')
  .pipe(
    withLatestFrom(Dispatch.getState('shipments.bufferData')),
    map(([save, shipments]) => shipments.map(shipment => mutations.createShipmentInput(shipment))),
    withLatestFrom(Dispatch.getState('view')),
    map(([shipment, view]) => ({ shipment, status: views[view.type]}))   
  )
  .subscribe(e => Dispatch.nextAction('Request.saveShipments', { type: 'mutation', query: mutations.MUTATE_UPSERT_SHIPMENTS, variables: { shipment: e.shipment, status: e.status } }))

// Dispatch.getAction('shipments.save')
//  .pipe(
//     withLatestFrom(Dispatch.getState('shipments')),
//     map(([save, shipments]) => shipments.map(shipment => mutations.createShipmentInput(shipment))),
//     withLatestFrom(Dispatch.getState('view')),
//     map(([shipment, view]) => ({ shipment, status: views[view.type]}))
//   )
//   .subscribe(e => Dispatch.nextAction('Request.saveShipments', { type: 'mutation', query: mutations.MUTATE_UPSERT_SHIPMENTS, variables: { shipment: e.shipment, status: e.status } }))

Dispatch.getAction('shipments.sendToSupplier')
  .pipe(
    map(e => {
      const elements = document.getElementsByClassName(e.tableName)
      const checked = _.filter(elements, element => element.checked)
      return {ids: checked.map(check => parseInt(check.id)), ...e}
    }),
    withLatestFrom(Dispatch.getState('view'), Dispatch.getState('user.email')),
    map(([e, view, email]) => ({ ...e, status: views[view.type], email }))
  )
  .subscribe(e => Dispatch.nextAction('Request.sendToSupplier', { type: 'mutation', query: mutations.MUTATE_SEND_SUPPLIER, variables: { 
    ids: e.ids, 
    checkNumber: e.checkNumber, 
    sendEmail: e.sendEmail, 
    toAddress: e.toAddress, 
    message: e.message,
    query: {
      status: e.status, 
    },
    replyTo: e.email 
  } }))

  Dispatch.getAction('shipments.sendToReferee')
    .pipe(
      map(e => {
        const elements = document.getElementsByClassName(e.tableName)
        const checked = _.filter(elements, element => element.checked)
        return {ids: checked.map(check => parseInt(check.id)), ...e}
      }),
      withLatestFrom(Dispatch.getState('view'), Dispatch.getState('user.email')),
      map(([e, view, email]) => ({ ...e, status: views[view.type], email }))
    )
    .subscribe(e => Dispatch.nextAction('Request.sendRefereeShipments', { 
      type: 'mutation', 
      query: mutations.MUTATE_SEND_REFEREE, 
      variables: { 
        ids: e.ids, 
        lab: e.lab, 
        sendEmail: e.sendEmail, 
        customerToAddress: e.customerToAddress, 
        customerMessage: e.customerMessage, 
        labToAddress: e.labToAddress, 
        labMessage: e.labMessage,
        replyTo: e.email,
        query: {
          status: e.status
        }
      } 
    }))

    Dispatch.getAction('shipments.sendSettlement')
    .pipe(
      map(e => {
        const elements = document.getElementsByClassName(e.tableName)
        const checked = _.filter(elements, element => element.checked)
        return {ids: checked.map(check => parseInt(check.id)), ...e}
      }),
      withLatestFrom(Dispatch.getState('view'), Dispatch.getState('user.email')),
      map(([e, view, email]) => ({ ...e, status: views[view.type], email }))
    )
    .subscribe(e => Dispatch.nextAction('Request.sendSettlement', { type: 'mutation', query: mutations.MUTATE_SEND_SETTLEMENT, variables: { 
      ids: e.ids, 
      checkNumber: e.checkNumber, 
      sendEmail: e.sendEmail, 
      toAddress: e.toAddress, 
      message: e.message,
      query: {
        status: e.status, 
      },
      replyTo: e.email 
    } }))

    Dispatch.getAction('shipments.refereeUpload')
      .pipe(
        withLatestFrom(Dispatch.getState('view')),
        map(([upload, view]) => ({ upload, status: views[view.type]}))
      )
    .subscribe(e => Dispatch.nextAction('Request.shipments.refereeUpload', { type: 'mutation', query: mutations.UPLOAD_REFEREE, variables: {id: e.upload?.id, file: e.upload?.file, query: {status: e.status} } }))

    Dispatch.getAction('shipments.downloadSettlement')
    .pipe(
      map(e => {
        const elements = document.getElementsByClassName(e.tableName)
        const checked = _.filter(elements, element => element.checked)
        return {ids: checked.map(check => parseInt(check.id)), ...e}
      }),
      withLatestFrom(Dispatch.getState('view')),
      map(([e, view]) => ({ ...e, status: views[view.type] }))
    )
    .subscribe(e => Dispatch.nextAction('Request.downloadSettlement', { type: 'mutation', query: mutations.DOWNLOAD_SETTLEMENT, variables: { 
      ids: e.ids, 
      checkNumber: e.checkNumber, 
      status: e.status,
    } }))

    Dispatch.getAction('Response.downloadSettlement')
    .pipe(
      filter(e => _.isNil(e.errors)),
      map(e => e.data.downloadSettlement)
    )
    .subscribe(e => {
      window.open(e)
    })

    Dispatch.getAction('shipments.delete')
    .pipe(
      map(e => {
        const elements = document.getElementsByClassName(e.tableName)
        const checked = _.filter(elements, element => element.checked)
        return {ids: checked.map(check => parseInt(check.id)), ...e}
      }),
    )
    .subscribe(e => Dispatch.nextAction('Request.shipments.delete', { type: 'mutation', query: mutations.MUTATE_DELETE_SHIPMENTS, variables: { 
      ids: e.ids,
    } }))

    Dispatch.getAction('shipments.sendDenied')
    .pipe(
      map(e => {
        const elements = document.getElementsByClassName(e.tableName)
        const checked = _.filter(elements, element => element.checked)
        return {ids: checked.map(check => parseInt(check.id)), ...e}
      }),
      withLatestFrom(Dispatch.getState('view'), Dispatch.getState('user.email')),
      map(([e, view, email]) => ({ ...e, status: views[view.type], email }))
    )
    .subscribe(e => Dispatch.nextAction('Request.sendDenied', { 
      type: 'mutation', 
      query: mutations.MUTATE_SEND_DENIED, 
      variables: { 
        ids: e.ids, 
        sendEmail: e.sendEmail, 
        customerToAddress: e.customerToAddress, 
        customerMessage: e.customerMessage, 
        replyTo: e.email,
        query: {
          status: e.status
        }
      } 
    }))

    Dispatch.getAction('shipments.importData')
        .subscribe(e => Dispatch.nextAction('Request.importData', { type: 'mutation', query: mutations.IMPORT_DATA, variables: {type: e.type, file: e.file } }))